export default {
  label: {
    agentNo: 'Tài khoản đại lý',
    amount: '	cập nhật số dư',
    beforeAmount: 'Số dư trước khi cập nhật',
    channelName: 'Tên kênh',
    channelType: 'loại thanh toán',
    createTime: 'thời gian giao dịch',
    id: 'Mã chính ID',
    merchatNo: 'Tên merchant',
    merchatOrderNo: 'mã giao dịch',
    transactionType: 'loại giao dịch',
    updateAmount: 'Số dư sau cập nhật',
    withdrawBack: 'Từ chối rút tiền trả về',
    sysMerchatOrderNo: 'Số thứ tự hệ thống'
  },
  types: [
    {
      label: 'Nạp vào',
      value: 1
    },
    {
      label: 'Rút tiền',
      value: 2
    },
    {
      label: 'Từ chối rút tiền trả về',
      value: 3
    },
    {
      label: 'chuyển số dư',
      value: 4
    },
    {
      label: 'chuyển ví',
      value: 5
    },
    {
      label: 'Khấu trừ thủ công',
      value: 6
    },
    {
      label: 'Nạp tiền thủ công',
      value: 7
    },
    {
      label: 'hoa hồng đại lý',
      value: 8
    },
  ]
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/walletRecord.js